module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN325_1782162306.bb71b29c.png";